export default "__VITE_ASSET__B7TNZ6Q0__"